/* eslint-disable */
import axios from 'axios'
import config from '@assets/config.json'
import qs from 'qs'
import { Message, Modal } from 'view-design'

// 通用 Module
const state = {
  login: false, // 登录状态
  token: '', // 默认token
  joinToken: '', // 默认token
  user: null, // 用户信息
  role: 0, // 0 = 展商   1 = 主办
  header: '',
  tokenHeaders: '',
  tokenTime: 0, // token过期时间
  auth: '', // 请求token的数据
  proCollectId: '', // 关注的产品Id
  exCollectId: '', // 关注的企业Id
  chanceCollectId: '', // 关注的供需Id
  formHeaders: {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  },
  uploadUrl: `${config.api.reqApi}/api/upload/images`, // 图片上传地址
  uploadVideoUrl: `${config.api.reqApi}/api/upload/videos`, // 视频上传地址
  refresh: true,
  exhibitionId: `${config.ExhibitionId}`,
  companyName: '',
  ExhibitionIdArr: [],
  isExLogin: null, //展商还是个人登录

  allAddress: [], // 国家/省份/城市/区县
  chinaAddress: [], // 省份/城市/区县
    exhibitionSetting: {
        // "0d236e01-c698-4ebd-9b17-fa2687d43a65": { order: 1, name: "2026春" },
        // "fdfcbf63-68f8-4be7-8e63-6dff02a54b4d": { order: 2, name: "40" },
        // "39eb2110-203f-4036-ad52-27b345b5129c": { order: 3, name: "93" },
        "868a0e65-70de-4027-ac46-67c221687962": { order: 4, name: "2026秋康复" },
        "000fe5f1-fd58-4cee-9946-d07fdf799347": { order: 5, name: "41届ICMD" },
        "e26c62a6-de1c-407b-979f-e1ea75211c22": { order: 6, name: "94届CMEF" },
    }
}
const mutations = {
  setExhibitionIdArr(state, data) {
    state.ExhibitionIdArr = data
  },
  setToken(state, data) {
    if (data) {
      state.tokenHeaders = {
        headers: {
          Authorization: 'Bearer ' + data,
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
      state.header = {
        headers: {
          Authorization: 'Bearer ' + data,
          'Content-Type': 'application/json; charset=UTF-8;'
        }
      }
    }
    state.token = data
  },
  setJoinToken(state, data) {
    state.joinToken = {
      headers: {
        Authorization: 'Bearer ' + data,
        'Content-Type': 'application/json; charset=UTF-8;'
      }
    }
  },
  setTokenTime(state, data) {
    state.tokenTime = data
  },
  setRefreshStatus(state, data) {
    state.refresh = data
  },
  setLogin(state, data) {
    state.login = data
  },
  setUser(state, data) {
    state.user = data
  },
  setIsExLogin(state, data) {
    state.isExLogin = data
  },

  setAuth(state, data) {
    state.auth = data
  },
  setRole(state, data) {
    state.role = data
  },
  setProCollectId(state, data) {
    state.proCollectId = data
  },
  setExCollectId(state, data) {
    state.exCollectId = data
  },
  setChanceCollectId(state, data) {
    state.chanceCollectId = data
  },
  setCompanyName(state, data) {
    state.companyName = data
  }
}
const getters = {
  getExhibitionIdArr: (state) => {
    return state.ExhibitionIdArr
  },
  getUploadUrl: (state) => {
    return state.uploadUrl
  },
  getUploadVideoUrl: (state) => {
    return state.uploadVideoUrl
  },
  getFormHeaders: (state) => {
    return state.formHeaders
  },
  getHeaders: (state) => {
    return state.header
  },
  getRefreshStatus: (state) => {
    return state.refresh
  },
  getTokenTime: (state) => {
    return state.tokenTime
  },
  getCompanyName: (state) => {
    return state.companyName
  },
  getToken: (state) => {
    const token = state.token || localStorage.getItem('token')
    state.token = token
    return state.token
  },
  getUser: (state) => {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user && !state.user) {
      state.user = user
    }
    return state.user
  },
  getIsExLogin: (state) => {
    return state.isExLogin
  },
  getLogin: (state) => {
    const login = JSON.parse(localStorage.getItem('login'))
    if (login) {
      state.login = login
    }
    return state.login
  },
  getAuth: (state) => {
    return state.auth
  },
  getRole: (state) => {
    return state.role
  },
  getExhibitionId: (state) => {
    return state.exhibitionId
  },
  getTokenHeaders: (state) => {
    return state.tokenHeaders
  },
  getProCollectId: (state) => {
    return state.proCollectId
  },
  getExCollectId: (state) => {
    return state.exCollectId
  },
  getChanceCollectId: (state) => {
    return state.chanceCollectId
  },

    getExhibitionSetting: (state) => {
      return state.exhibitionSetting
    },
  
}
const actions = {
  /**
   *  获取数据类型通用写法封装
   * @param {*} param0 
   * @param {*} data { url: '基础接口的传入字符串', opt: 分页请求的参数}
   * url替换 <控制器名称>  【 /api/v1/<控制器名称>/wherepage 】
   *opt:  pageSize 页条数
          pageIndex 页码
          sorts[] 排序属性 
            propertyName 属性名称（必须是实体属性名称，且区分大小写，如果属性名称以小写开头，请把首字母大写）
            ascending 是否升序
          wheres 条件集
            type 条件类型
              0 条件组
              1 字段
              2 在值1与值2之间
              3 不在值1与值2之间
              4 符合给定的条件
              5 不符合给定的条件
            wheres 条件对象
   */
  getWherepage({ state }, data) {
    return new Promise((resolve, reject) => {
      const defaultOpt = {
        pageSize: 1000,
        sorts: [{ propertyName: 'showIndex', ascending: true }]
      }
      const opt = data.opt
        ? Object.assign({}, defaultOpt, data.opt)
        : defaultOpt
      axios
        .post(`${state.reqApi}/api/v1/${data.url}/wherepage`, opt)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  // 移动端修改订单报名状态
  OrderChangeState({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/ApplyCompanyOrder/OrderChangeState?applycompanyId=${opt.applycompanyId}&exhibitonid=${opt.exhibitonid}`,
          rootState.header2
        )
        .then((res) => {
          if (res.data && res.status === 200) {
            resolve(res.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getStaff({ state }, id) {
    // 获取客服
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/staff/GetDefault?compId=${id}`,
          state.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  uploadImages({ state }) {
    // 上传图片
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/upload/images`, {}, state.formHeaders)
        .then((data) => {
          if (data.data) {
            if (data.data.successed) {
              Message.success('验证码已发送')
            } else {
              Message.success('验证码发送失败')
            }
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  refreshToken({ state, rootGetters, rootState, commit }) {
    console.log('refreshToken')
    const opt = {
      grant_type: 'refresh_token',
      client_id: 'cloud.exhibition',
      client_secret: 'secret',
      refresh_token: state.auth.refresh_token
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/connect/token`,
          qs.stringify(opt),
          rootState.formHeaders
        )
        .then((data) => {
          if (data.data) {
            commit('setAuth', data.data, { root: true })
            commit('setToken', data.data.access_token, { root: true })
            commit(
              'setTokenTime',
              data.data.expires_in * 1000 + new Date().getTime(),
              { root: true }
            )
            commit('setRefreshStatus', true, { root: true })
            resolve(data.data)
          }
        })
        .catch((err) => {
          if (err.response) {
            console.log(err.response.data)
          }
        })
    })
  },
  getJoinToken({ rootState, commit }, opt) {
    // 获取token
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/connect/token`,
          qs.stringify(opt),
          rootState.formHeaders
        )
        .then((data) => {
          if (data) {
            commit('setAuth', data.data, { root: true })
            resolve(data)
          }
        })
        .catch((err) => {
          let req = err.response
          if (req && req.data && req.data.error_description) {
            if (req.data.code === 4002) {
              Message.error({
                content: '登录身份有误，请重新确认',
                duration: 2
              })
            } else {
              Message.error({
                content: req.data.error_description,
                duration: 2
              })
            }
          }
          resolve(null)
        })
    })
  },
  getJoinTokenEn({ rootState, commit }, opt) {
    // 获取token
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/connect/token`,
          qs.stringify(opt),
          rootState.formHeaders
        )
        .then((data) => {
          if (data) {
            commit('setAuth', data.data, { root: true })
            resolve(data)
          }
        })
        .catch((err) => {
          let req = err.response
          if (req && req.data && req.data.error_description) {
            if (req.data.code === 4002) {
              Message.error({
                content: 'Login identity error, please confirm again',
                duration: 2
              })
            } else {
              Message.error({
                content: 'Wrong user name or password',
                duration: 2
              })
            }
          }
          resolve(null)
        })
    })
  },
  getJoinUser({ rootState, commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.auth}/api/account/GetInfo`, rootState.joinToken)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getJoinCompany({ rootState }, id) {
    // 根据用户id获取公司信息
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/company/GetByUserId?userId=${id}`,
          rootState.joinToken
        )
        .then((data) => {
          resolve(data.data)
        })
    })
  },
  getExIdByUserId({ rootState }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/Join/GetJoinRelevant?userid=${id}`,
          rootState.joinToken
        )
        .then((data) => {
          resolve(data.data)
        })
    })
  },
  // 获取公司联系人
  getYesLink({ rootState }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/contact/GetByCompIdForExhibitor?compId=${id}`,
          rootState.joinToken
        )
        .then((data) => {
          resolve(data.data)
        })
    })
  },
  getExhibitionById({ rootState }, id) {
    // 根据展会id
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/exhibition?id=${id}`,
          rootState.joinToken
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getJoinInfo({ rootState }, opt) {
    // 判断是否参展
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/join/GetJoin`, opt, rootState.joinToken)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  saveUser({ rootState }, opt) {
    // 修改用户的信息
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/UserInfo/Save`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  getHostNews({ rootState }, opt) {
    // 获取行业动态
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/NewsHost/All`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getExNews({ rootState }, opt) {
    // 获取企业动态
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/NewsExhibitor/All?show=1`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getNewsById({ rootState }, id) {
    // 根据Id获取动态详情
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/NewsExhibitor?id=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getHostNewsById({ rootState }, id) {
    // 根据Id获取行业动态详情
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/NewsHost?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getPlanById({ rootState }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/ExhibitionPlan?id=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  getMarathon({ rootState }) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/TopicalSubject/GetList`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  // ----------------------------参展申请 - 相关接口---------------------------- //
  getNature({ rootState }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/Nature/GetList`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 获取企业经营类别
  getBusinessType({ rootState }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/BusinessType/GetList`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  // 获取大洲
  getAreaAll({ rootState }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/ApplyArea/GetAll`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 根据大洲获取国家
  getCountryByArea({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/ApplyCountry/GetList?areaName=${opt}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  //获取国家
  getCountry({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/ApplyCountry/GetList`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  //获取国家 新
  getCountryNew({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `https://oss-ecrm.reed-sinopharm.com/host/data-to-blob/countries/country-province-city-county.json`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 新增参展申请
  addApplyCompany({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/ApplyCompany`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 修改参展申请
  editApplyCompany({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/ApplyCompany`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 获取基本信息
  getApplyCompanyBasic({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/ApplyCompany?id=${opt}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 获取参展展会
  getApplyExhibition({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/ApplyExhibition/GetAll`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 获取参展展会 - index排序
  getApplyExhibitionByIndex({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/ApplyExhibition/GetAll2`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 获取参展申请流程
  getApplyFlow({ rootState }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/ApplyFlow/GetAll`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 获取参展申请流程进度
  getApplyFlowSpeed({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/ApplyFlow/GetCurrentSpeed?applyId=${opt}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 获取参展申请流程
  getDePjNameGroup({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/DePjNameGroup/GetList`,
          opt,
          rootState.header
        )
        .then((data) => {
          console.log(data, '获取的结果')
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 获取参展申请流程 new
  getDeTermGetListByType({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/DeTerm/GetListByType?exhibitionId=${opt.ExhibitionId}`,
          opt,
          rootState.header
        )
        .then((data) => {
          console.log(data, '获取的结果')
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 固定费换接口
  getForeignList({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/DePjNameGroup/GetForeignList`,
          opt,
          rootState.header
        )
        .then((data) => {
          console.log(data, '获取的结果')
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 获取组团列表
  getDeTerm({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/DeTerm/GetList?exhibitionId=${opt}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 选择展会及展位类型
  applyCompanyOrder({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ApplyCompanyOrder`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 修改展会及展位类型
  editCompanyOrder({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `${config.api.reqApi}/api/ApplyCompanyOrder`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 参展申请 - 订单
  addApplyOrder({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ApplyCompanyOrder/OrderAdd`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 参展申请 - 修改订单
  editApplyOrder({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ApplyCompanyOrder/OrderEdit`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 参展申请 - 获取完整订单信息
  getOrderDetail({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/ApplyCompanyOrder/GetOrder?id=${opt}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 参展申请 - 更新会刊信息
  updateIntroduction({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ApplyCompanyOrder/IntroductionUpdate`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  // 参展申请 - 完成报名
  finishApplyOperate({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ApplyCompanyOrder/UpdateApplyFileLink`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 参展申请 - 完成报名(英文)
  finishApplyOperateEn({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ApplyCompanyOrder/UpdateApplyFileLinkEn`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 参展申请 - 开启新流程
  openNewApply({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ApplyFlow/CreateByApplyId`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  // 参展申请 - 获取组团单位列表
  getGroup({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/DeTerm/GetList?exhibitionId=${opt}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 参展申请 - 根据组团Id获取组团信息
  getGroupInfoById({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/DeTerm?id=${opt}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 参展申请 - 获取展会下载文件
  getFile({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ApplyExhibitionFile/GetByName`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
          if (data.status === 204) {
            resolve('No Content')
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 参展申请 - 获取申请表
  getwordfile({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/file?key=${opt.key}`, {
          responseType: 'arraybuffer',
          ...rootState.header
        })
        .then((data) => {
          if (data.data) {
            const aLink = document.createElement('a')
            let blob = new Blob([data.data], { type: 'application/msword' })
            aLink.href = URL.createObjectURL(blob)
            aLink.setAttribute('download', opt.name) // 设置下载文件名称
            aLink.click()
            //document.body.appendChild(aLink)
            this.$refs.loadElement.appendChild(aLink)

            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 参展申请 - 获取申请表1
  getwordfile1({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${opt.key}`, { responseType: 'arraybuffer', ...rootState.header })
        .then((data) => {
          if (data.data) {
            const aLink = document.createElement('a')
            let blob = new Blob([data.data], { type: 'application/msword' })
            aLink.href = URL.createObjectURL(blob)
            aLink.setAttribute('download', opt.name) // 设置下载文件名称
            aLink.click()
            //document.body.appendChild(aLink)
            this.$refs.loadElement.appendChild(aLink)

            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  //展团获取申请表
  getwordfileTerm({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/file?key=${opt.key}`, {
          responseType: 'arraybuffer',
          ...rootState.header
        })
        .then((data) => {
          if (data.data) {
            const aLink = document.createElement('a')
            let blob = new Blob([data.data], { type: 'application/msword' })
            aLink.href = URL.createObjectURL(blob)
            aLink.setAttribute('download', opt.name) // 设置下载文件名称
            aLink.click()
            //document.body.appendChild(aLink)
            this.$refs.loadElement.appendChild(aLink)

            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  // 参展申请 - 获取申请表
  getwordfileEn({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/file?key=${opt.key}`, {
          responseType: 'arraybuffer',
          ...rootState.header
        })
        .then((data) => {
          if (data.data) {
            const aLink = document.createElement('a')
            let blob = new Blob([data.data], { type: 'application/msword' })
            console.log(data, '文件名字')

            aLink.href = URL.createObjectURL(blob)

            aLink.setAttribute('download', opt.name) // 设置下载文件名称
            aLink.click()
            //document.body.appendChild(aLink)
            this.$refs.loadElement.appendChild(aLink)

            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 参展申请 - 获取英文展团申请表
  getwordfileTermEn({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/file?key=${opt.key}`, {
          responseType: 'arraybuffer',
          ...rootState.header
        })
        .then((data) => {
          if (data.data) {
            const aLink = document.createElement('a')
            let blob = new Blob([data.data], { type: 'application/msword' })
            console.log(data, '文件名字')

            aLink.href = URL.createObjectURL(blob)

            aLink.setAttribute('download', opt.name) // 设置下载文件名称
            aLink.click()
            //document.body.appendChild(aLink)
            this.$refs.loadElement.appendChild(aLink)

            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 参展申请 - 获取申请表下载地址n
  getApplyConfig({ rootState }, key) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/ApplyConfig/GetConfig`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  //现场报名新增
  ApplyScene({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/ApplyScene`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  //获取是否参加了上一届展会
  getjoin({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ApplyCompany/IsJoinEx`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  //获取上一次申报的信息，登录后获取
  getCompanyBasicInfo({ rootState }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/applycompany/getByCompId?compId=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve('')
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  //获取展团信息
  getDeTerm({ rootState }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/DeTerm?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve('')
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getAllConfiSettle({ commit, rootState }, type) {
    // 根据id获取用户详细信息；
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/Exhibition/GetAllConfiSettle?type=${type}`,
          rootState.header
        )
        .then(({ data }) => {
          if (data) {
            if (data && data[0]) {
              commit('setExhibitionIdArr', data[0].exhibitionIds, {
                root: true
              })
            }
            resolve(data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },

  //获取展团
  getPavilion({ rootState }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/DeTerm/GetListByType?exhibitionId=${id}&typeLanguage=英文`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve('')
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  //   根据展团币种获取订单
  getOrderCurrency({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/DePjNameGroup/GetForeignList`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  //   ThirdPartyInfo 第三方展区/商品操作

  // 获取展区列表
  getAllArea({ rootState }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/ThirdPartyInfo/getAllArea?exhibitionId=${id}&isEnable=true`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  //   /api/ThirdPartyInfo/getCommodities 获取商品信息
  getCommodities({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ThirdPartyInfo/getCommodities`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  }
}
export default {
  state,
  actions,
  mutations,
  getters
}
